module.exports = __webpack_public_path__ + "static/media/29.2fc9aab6.png";